import React, { Component } from 'react'
import { withStyles } from 'material-ui/styles'
import { withApollo } from 'react-apollo'
import { inject, observer } from 'mobx-react'
import { Tabs, Typography, Button } from 'material-ui'
import { ALABASTER, GC_USER_ID } from '@/constants'
import { Link, withRouter } from 'react-router-dom'
import { graphql } from 'react-apollo'
import HeaderAlchemy from '@/components/HeaderAlchemy'
import PlayCircleOutlineIcon from 'material-ui-icons/PlayCircleOutline'
import ImportContactsIcon from 'material-ui-icons/ImportContacts'
import SettingsOverscanIcon from 'material-ui-icons/SettingsOverscan'
import BlurOnIcon from 'material-ui-icons/BlurOn'
import LocalFloristIcon from 'material-ui-icons/LocalFlorist'
import AttachMoneyIcon from 'material-ui-icons/AttachMoney'

import { CREATE_DATASET, UPDATE_DATASET } from '@/graphql/mutations/dataset'
import {
  READ_DATASETNAMEDES,
  READ_DATASETNAME
} from '@/graphql/queries/dataset'

const styles = theme => ({
  root: {
    flexGrow: 1
  },
  toolbar: {
    backgroundColor: 'white',
    color: 'white'
  },
  startPage: {
    textAlign: 'center',
    justifyContent: 'center',
    alignItems: 'center',
    color: 'grey',
    opacity: 0.8,
    backgroundColor: 'white',
    width: '100%',
    height: window.innerHeight - 112
  },
  startPageEmpty: {
    textAlign: 'center',
    justifyContent: 'center',
    alignItems: 'center',
    color: 'grey',
    opacity: 0.8,
    width: '100%',
    height: window.innerWidth * 1.2
  },
  startPageEmptyGrey: {
    textAlign: 'center',
    display: 'grid',
    justifyContent: 'center',
    alignItems: 'center',
    fontSize: 12,
    color: 'grey',
    opacity: 0.8,
    backgroundColor: ALABASTER,
    width: '100%',
    height: 200
  },
  icon: {
    backgroundColor: 'rgba(80, 227, 194, 1)',
    boxShadow: '0px 5px 30px #79DBC0',
    width: 220,
    height: 50
  },
  iconOutline: {
    backgroundColor: 'rgba(255, 255, 255, .6)',
    boxShadow: '0px 5px 30px #dddddd',
    width: 180,
    height: 40
  },
  iconOutlineL: {
    backgroundColor: 'rgba(255, 255, 255, .6)',
    boxShadow: '0px 5px 30px #dddddd',
    width: 230,
    height: 40
  },
  iconOutlineXL: {
    backgroundColor: 'rgba(255, 255, 255, .6)',
    boxShadow: '0px 5px 30px #dddddd',
    width: 260,
    height: 40
  },
  editIcons: {
    color: 'rgba(0, 0, 0, .1)',
    width: 190,
    height: 190
  }
})

@withApollo
@inject('resultTrackers')
@inject('resultTrackerPref')
@observer
@graphql(CREATE_DATASET, { name: 'createDataSet' })
@graphql(UPDATE_DATASET, { name: 'UpdateDataSet' })
@graphql(READ_DATASETNAME, {
  name: 'readUserTrackerPreference',
  options: ({ match }) => ({
    variables: {
      dataName: 'defaultUserTrackerPreference',
      userId: global.localStorage.getItem(GC_USER_ID)
        ? global.localStorage.getItem(GC_USER_ID)
        : 'NA'
    }
  })
})
@graphql(READ_DATASETNAMEDES, {
  name: 'readAlchemyTrackerListDefault',
  options: ({ match }) => ({
    variables: {
      dataName: 'defaultAlchemyTrackerListSharedToPublic',
      dataDescription: 'defaultAlchemyTrackerListSharedToPublic'
    }
  })
})
@graphql(UPDATE_DATASET, { name: 'UpdateDataSet' })
@withRouter
@withStyles(styles)
export default class AlchemyStart extends Component {
  constructor(props) {
    super(props)

    this.state = {}
  }

  trackerActivated = (id, value) => {
    // check login: if not, send to sign up page
    const userId = global.localStorage.getItem(GC_USER_ID)
    if (!userId) {
      this.props.history.push(`/register`)
      return
    }

    // load readUserTrackerPreference
    if (this.props.readUserTrackerPreference.loading) {
      return <div>Loading user tracker preference data ... </div>
    }

    // check readUserTrackerPreference length
    if (this.props.readUserTrackerPreference.allDataSets.length === 1) {
      // check datapoints
      if (this.props.readUserTrackerPreference.allDataSets[0].dataPoints) {
        var l = JSON.parse(
          this.props.readUserTrackerPreference.allDataSets[0].dataPoints
        ).length
        if (l > 0) {
          // copy pref data from database to store
          this.props.resultTrackerPref.updateTrackers(
            JSON.parse(
              this.props.readUserTrackerPreference.allDataSets[0].dataPoints
            )
          )
          this.props.resultTrackerPref.updateTrackersActiveFromAll()
        } else {
          // update store with []
          this.props.resultTrackerPref.updateTrackers([])
          this.props.resultTrackerPref.updateTrackersActiveFromAll()
        }
      } else {
        //('there is user tracker pref table, but no dataPoints ')
        // update store with []
        this.props.resultTrackerPref.updateTrackers([])
        this.props.resultTrackerPref.updateTrackersActiveFromAll()
      }
    } else if (this.props.readUserTrackerPreference.allDataSets.length === 0) {
      // create user pref data
      if (!this.props.resultTrackerPref.created) {
        // update store with []
        this.props.resultTrackerPref.updateTrackers([])

        // get tracker info from resultTrackers by id
        this.props.resultTrackers.updateTrackerById(id)
        if (this.props.resultTrackers.tracker.length === 0) {
          return (
            <div>
              Tracker not found: contact support team to add this tracker
            </div>
          )
        }

        // add store with current tracker
        this.props.resultTrackerPref.trackers.splice(0, 0, {
          id: this.props.resultTrackers.tracker.id,
          name: this.props.resultTrackers.tracker.name,
          description: this.props.resultTrackers.tracker.description,
          img: '/cloud_done.png',
          isActive: '1'
        })
        this.props.resultTrackerPref.updateTrackersActiveFromAll()

        // create table in database
        //('to create defaultUserTrackerPreference table')
        this.props.resultTrackerPref.tabSelected = parseInt(id, 10)
        this.createDataSetUserTrackerPref(
          JSON.stringify(this.props.resultTrackerPref.trackers)
        )
        if (this.props.resultTrackerPref.datasetId !== '') {
          this.props.resultTrackerPref.updateCreated()
        } else {
          console.log('table is not created yet')
        }
        return
      } else {
        // ? not sure if this is needed
        console.log(
          'not created? not sure if this is needed: update defaultUserTrackerPreference table'
        )
        this.props.resultTrackerPref.updateTrackers(
          JSON.stringify(
            this.props.readUserTrackerPreference.allDataSets[0].dataPoints
          )
        )
        this.props.resultTrackerPref.updateTrackersActiveFromAll()
      }
    } else {
      return (
        <div>
          Error, please contact our support team [resultTrackerPref:{' '}
          {this.props.resultTrackerPref.allDataSets.length}]
        </div>
      )
    }

    if (this.props.resultTrackerPref.trackers.length === 0) {
      // get tracker info from resultTrackers by id
      this.props.resultTrackers.updateTrackerById(id)
      if (this.props.resultTrackers.tracker.length === 0) {
        return (
          <div>Tracker not found: contact support team to add this tracker</div>
        )
      }

      // add tracker to tracker pref store
      this.props.resultTrackerPref.trackers.splice(0, 0, {
        id: this.props.resultTrackers.tracker.id,
        name: this.props.resultTrackers.tracker.name,
        description: this.props.resultTrackers.tracker.description,
        img: '/cloud_done.png',
        isActive: '1'
      })
      this.props.resultTrackerPref.updateTrackersActiveFromAll()
    } else {
      // check if tracker is there
      this.props.resultTrackerPref.updateUserTrackerPreference(id, value)
      this.props.resultTrackerPref.updateTrackersActiveFromAll()
    }

    this.props.resultTrackerPref.tabSelected = parseInt(id, 10)
    this.updateTrackerPref()
  }

  updateTrackerPref = () => {
    //update to dataset
    this.updateDataPointsUserTrackerPref(
      JSON.stringify(this.props.resultTrackerPref.trackers)
    )
  }

  createDataSetUserTrackerPref = async dataPoints => {
    const userId = global.localStorage.getItem(GC_USER_ID)
    if (!userId) {
      this.props.history.push(`/register`)
      return
    }
    // if default table is there, refuse to create
    if (this.props.readUserTrackerPreference.allDataSets.length > 0) {
      console.log('there is already default user book preference table there')
      return
    }

    try {
      await this.props.createDataSet({
        variables: {
          name: 'defaultUserTrackerPreference',
          description: 'defaultUserTrackerPreference',
          dataPoints: dataPoints,
          userId: userId
        },
        update: (store, { data: { createDataSet } }) => {
          console.log('default user tracker preference table created')
          this.props.resultTrackerPref.datasetId = createDataSet.id
          this.props.history.push('/')
        }
      })
    } catch (e) {
      console.log(e)
    }
  }

  updateDataPointsUserTrackerPref = async dataPoints => {
    if (this.props.readUserTrackerPreference.allDataSets.length === 0) {
      if (this.props.resultTrackerPref.datasetId === '') {
        //('readUserTrackerPreference is not created')
        return <div>readUserTrackerPreference is not created </div>
      }

      await this.props.UpdateDataSet({
        variables: {
          datasetId: this.props.resultTrackerPref.datasetId,
          dataPoints: dataPoints
        },
        update: () => {
          //('Tracker preference data updated: readUserTrackerPreference')
          this.props.history.push('/')
        }
      })
    } else if (this.props.readUserTrackerPreference.allDataSets.length === 1) {
      await this.props.UpdateDataSet({
        variables: {
          datasetId: this.props.readUserTrackerPreference.allDataSets[0].id,
          dataPoints: dataPoints
        },
        update: () => {
          //('Tracker preference data updated: readUserTrackerPreference')
          this.props.history.push('/')
        }
      })
    } else {
      console.log(
        'error: ' +
          this.props.readUserTrackerPreference.allDataSets.length +
          ' readUserTrackerPreference'
      )
    }
  }

  render() {
    const userId = global.localStorage.getItem(GC_USER_ID)
    const { classes } = this.props
    var allTrackerPref = []
    if (
      this.props.readUserTrackerPreference &&
      this.props.readUserTrackerPreference.loading
    ) {
      return <div>Loading</div>
    }

    if (
      this.props.readUserTrackerPreference &&
      this.props.readUserTrackerPreference.error
    ) {
      if (!userId) {
        console.log('not logged in')
      }
    }

    //get or create tracker list
    if (this.props.readAlchemyTrackerListDefault.loading) {
      return <div>Loading tracker data ... </div>
    }

    if (
      this.props.readAlchemyTrackerListDefault &&
      this.props.readAlchemyTrackerListDefault.error
    ) {
      return <div>Error: readAlchemyTrackerListDefault</div>
    }

    if (
      this.props.resultTrackers.trackers.length === 0 &&
      !this.props.resultTrackers.created
    ) {
      if (this.props.readAlchemyTrackerListDefault.allDataSets.length === 1) {
        if (
          this.props.readAlchemyTrackerListDefault.allDataSets[0].dataPoints !==
          ''
        ) {
          //('defualt tracker table is there.')
          this.props.resultTrackers.updateTrackers(
            JSON.parse(
              this.props.readAlchemyTrackerListDefault.allDataSets[0].dataPoints
            )
          )
        }
      } else if (
        this.props.readAlchemyTrackerListDefault.allDataSets.length === 0
      ) {
        console.log('defualt public tracker list table to be added')
      } else {
        return (
          <div>
            Error, please contact our support team
            [readAlchemyTrackerListDefault:{' '}
            {this.props.readAlchemyTrackerListDefault.allDataSets.length}]
          </div>
        )
      }
    }

    // get or create user tracker preference
    if (
      this.props.resultTrackerPref.trackers.length === 0 ||
      this.props.resultTrackerPref.userId !== userId ||
      !this.props.resultTrackerPref.userId
    ) {
      if (this.props.readUserTrackerPreference.allDataSets) {
        if (this.props.readUserTrackerPreference.allDataSets.length === 1) {
          if (
            this.props.readUserTrackerPreference.allDataSets[0].dataPoints !==
            ''
          ) {
            allTrackerPref = JSON.parse(
              this.props.readUserTrackerPreference.allDataSets[0].dataPoints
            )
            this.props.resultTrackerPref.updateTrackers(allTrackerPref)
            this.props.resultTrackerPref.updateTrackersActiveFromAll()
            this.props.resultTrackerPref.userId = userId
          }
        } else if (
          this.props.readUserTrackerPreference.allDataSets.length === 0
        ) {
          this.props.resultTrackerPref.updateTrackers([])
          this.props.resultTrackerPref.updateTrackersActiveFromAll()
          this.props.resultTrackerPref.userId = userId
        } else {
          return (
            <div>
              Error, please contact our support team [readUserTrackerPreference:{' '}
              {this.props.readUserTrackerPreference.allDataSets.length}]
            </div>
          )
        }
      }
    }

    var activeTabs = this.props.resultTrackerPref.trackersActive
    var bodyWeightTab = activeTabs.filter(t => t.id === 1)
    var readingTab = activeTabs.filter(t => t.id === 2)
    var bodyTemperatureTab = activeTabs.filter(t => t.id === 3)

    return (
      <div>
        <HeaderAlchemy />
        <Tabs className={classes.toolbar} centered />
        {userId && readingTab.length === 1 ? (
          ''
        ) : (
          <div
            key={'readingTab'}
            className={classes.startPageEmpty}
            style={{
              backgroundColor: 'white'
            }}
          >
            <Typography
              variant="title"
              id="modal-title"
              style={{
                width: '80%',
                paddingLeft: '10%',
                paddingTop: 80,
                paddingBottom: 16,
                fontSize: 28,
                color: 'grey'
              }}
            >
              Reading, Daily, Happier and Smarter
            </Typography>
            <Typography
              variant="body1"
              id="modal-title"
              style={{
                width: '80%',
                paddingLeft: '10%',
                paddingBottom: 20,
                fontSize: 18,
                color: 'grey'
              }}
            >
              Read 30 Minutes, A Daily Goal To Reinvent Yourself
            </Typography>
            <div
              style={{
                width: window.innerWidth,
                position: 'relative',
                left: -30,
                textAlign: 'left',
                top: 0
              }}
            >
              <ImportContactsIcon className={classes.editIcons} />
            </div>
            <div
              style={{
                position: 'relative',
                right: 0,
                top: 0
              }}
            >
              <Button
                className={classes.iconOutline}
                size="large"
                onClick={() => this.trackerActivated(2, '1')}
              >
                <Typography
                  variant="title"
                  style={{ fontSize: 20, color: '#20c5a2' }}
                >
                  Track Reading
                </Typography>
              </Button>
            </div>
          </div>
        )}
        {
          <div className={classes.root}>
            <div className={classes.startPage}>
              <Typography
                variant="title"
                id="modal-title"
                style={{
                  width: '80%',
                  paddingBottom: 16,
                  paddingLeft: '10%',
                  padding: '10%',
                  fontSize: 28,
                  color: 'grey'
                }}
              >
                {!userId
                  ? 'Nothing Is Better Than Feeling On Track'
                  : this.props.resultTrackerPref.trackersActive.length === 0
                    ? 'Nothing Is Better Than Feeling On Track'
                    : this.props.resultTrackerPref.trackersActive.length === 1
                      ? 'Awesome, you enabled ' +
                        this.props.resultTrackerPref.trackersActive.length +
                        ' tracking!'
                      : 'Woohoo, you enabled ' +
                        this.props.resultTrackerPref.trackersActive.length +
                        ' trackings!'}
              </Typography>
              <Typography
                variant="body1"
                id="modal-title"
                style={{
                  width: '80%',
                  paddingBottom: 20,
                  paddingLeft: '10%',
                  fontSize: 18,
                  color: 'grey'
                }}
              >
                Track what matters. Be happier.
              </Typography>
              <div
                style={{
                  width: '80%',
                  paddingTop: 36,
                  paddingLeft: '10%',
                  paddingBottom: 22
                }}
              >
                <Button
                  className={classes.icon}
                  size="large"
                  component={Link}
                  to="/preference"
                >
                  <Typography
                    variant="title"
                    style={{ fontSize: 20, color: 'white' }}
                  >
                    {!userId
                      ? 'Start Tracking'
                      : this.props.resultTrackerPref.trackersActive.length === 0
                        ? 'Start Tracking'
                        : 'Track More'}
                  </Typography>
                </Button>
              </div>

              <Typography
                variant="caption"
                id="modal-title"
                style={{
                  fontSize: 15,
                  color: 'grey',
                  alignItems: 'center',
                  alignContent: 'center',
                  display: 'flex',
                  marginLeft: window.innerWidth * 0.3
                }}
              >
                <PlayCircleOutlineIcon style={{ color: 'lightgrey' }} /> Watch
                the video
              </Typography>
              <div
                style={{
                  width: window.innerWidth,
                  position: 'absolute',
                  left: 0
                }}
              >
                <img
                  src={process.env.PUBLIC_URL + '/bg_414.png'}
                  alt="bg"
                  width={window.innerWidth}
                />
              </div>
            </div>
          </div>
        }
        <div
          key={'fina_track'}
          className={classes.startPageEmpty}
          style={{
            backgroundColor: 'rgba(0, 140, 255, .05)'
          }}
        >
          <Typography
            variant="title"
            id="modal-title"
            style={{
              width: '80%',
              paddingLeft: '10%',
              paddingTop: 80,
              paddingBottom: 16,
              fontSize: 28,
              color: 'grey'
            }}
          >
            Spend Smart. More Savings.
          </Typography>
          <Typography
            variant="body1"
            id="modal-title"
            style={{
              width: '80%',
              paddingLeft: '10%',
              paddingBottom: 20,
              fontSize: 18,
              color: 'grey'
            }}
          >
            Track Expense For Financial Benefits
          </Typography>
          <div
            style={{
              width: window.innerWidth,
              position: 'relative',
              left: -30,
              textAlign: 'left',
              top: 0
            }}
          >
            <AttachMoneyIcon className={classes.editIcons} />
          </div>
          <div
            style={{
              position: 'relative',
              right: 0,
              top: 0
            }}
          >
            <Button className={classes.iconOutline} size="large">
              <Typography
                variant="title"
                style={{ fontSize: 20, color: '#20c5a2' }}
              >
                Track Expense
              </Typography>
            </Button>
            <Typography
              variant="title"
              style={{ fontSize: 18, color: 'lightgrey' }}
            >
              Coming Soon
            </Typography>
          </div>
        </div>
        {userId && bodyWeightTab.length === 1 ? (
          ''
        ) : (
          <div
            key={'bodyWeightTab'}
            className={classes.startPageEmpty}
            style={{
              backgroundColor: 'rgba(80, 227, 194, .1)'
            }}
          >
            <Typography
              variant="title"
              id="modal-title"
              style={{
                width: '80%',
                paddingLeft: '10%',
                paddingTop: 80,
                paddingBottom: 16,
                fontSize: 28,
                color: 'grey'
              }}
            >
              Weight Loss/Gain, Faster With Tracking
            </Typography>
            <Typography
              variant="body1"
              id="modal-title"
              style={{
                width: '80%',
                paddingLeft: '10%',
                paddingBottom: 20,
                fontSize: 18,
                color: 'grey'
              }}
            >
              Weight Tracking Helps To Reach Body Weight Goals
            </Typography>
            <div
              style={{
                width: window.innerWidth,
                position: 'relative',
                left: -30,
                textAlign: 'left',
                top: 0
              }}
            >
              <SettingsOverscanIcon className={classes.editIcons} />
            </div>
            <div
              style={{
                position: 'relative',
                right: 0,
                top: 0
              }}
            >
              <Button className={classes.iconOutlineL} size="large">
                <Typography
                  variant="title"
                  style={{ fontSize: 20, color: '#20c5a2' }}
                >
                  Track Body Weight
                </Typography>
              </Button>
              <Typography
                variant="title"
                style={{ fontSize: 18, color: 'lightgrey' }}
              >
                Coming Soon
              </Typography>
            </div>
          </div>
        )}
        {userId && bodyTemperatureTab.length === 1 ? (
          ''
        ) : (
          <div
            key={'bodyTemperatureTab'}
            className={classes.startPageEmpty}
            style={{
              backgroundColor: ALABASTER
            }}
          >
            <Typography
              variant="title"
              id="modal-title"
              style={{
                width: '80%',
                paddingLeft: '10%',
                paddingTop: 80,
                paddingBottom: 16,
                fontSize: 28,
                color: 'grey'
              }}
            >
              Measure Body Temperature
            </Typography>
            <Typography
              variant="body1"
              id="modal-title"
              style={{
                width: '80%',
                paddingLeft: '10%',
                paddingBottom: 20,
                fontSize: 18,
                color: 'grey'
              }}
            >
              Healthier to be on track
            </Typography>
            <div
              style={{
                width: window.innerWidth,
                position: 'relative',
                left: -30,
                textAlign: 'left',
                top: 0
              }}
            >
              <BlurOnIcon className={classes.editIcons} />
            </div>
            <div
              style={{
                position: 'relative',
                right: 0,
                top: 0
              }}
            >
              <Button
                className={classes.iconOutlineXL}
                size="large"
                variant="flat"
              >
                <Typography
                  variant="title"
                  style={{ fontSize: 18, color: '#20c5a2' }}
                >
                  Track Body Temperature
                </Typography>
              </Button>
              <Typography
                variant="title"
                style={{ fontSize: 18, color: 'lightgrey' }}
              >
                Coming Soon
              </Typography>
            </div>
          </div>
        )}
        <div
          key={'track_carbon'}
          className={classes.startPageEmpty}
          style={{
            backgroundColor: 'rgba(204, 252, 0, .05)'
          }}
        >
          <Typography
            variant="title"
            id="modal-title"
            style={{
              width: '80%',
              paddingLeft: '10%',
              paddingTop: 80,
              paddingBottom: 16,
              fontSize: 28,
              color: 'grey'
            }}
          >
            Less Carbon. Better Nature Impact.
          </Typography>
          <Typography
            variant="body1"
            id="modal-title"
            style={{
              width: '80%',
              paddingLeft: '10%',
              paddingBottom: 20,
              fontSize: 18,
              color: 'grey'
            }}
          >
            Track Carbon Saved For More Climate Benefits
          </Typography>
          <div
            style={{
              width: window.innerWidth,
              position: 'relative',
              left: -30,
              textAlign: 'left',
              top: 0
            }}
          >
            <LocalFloristIcon className={classes.editIcons} />
          </div>
          <div
            style={{
              position: 'relative',
              right: 0,
              top: 0
            }}
          >
            <Button
              className={classes.iconOutlineL}
              size="large"
              variant="flat"
            >
              <Typography
                variant="title"
                style={{ fontSize: 20, color: '#20c5a2' }}
              >
                Track Carbon Saved
              </Typography>
            </Button>
            <Typography
              variant="title"
              style={{ fontSize: 18, color: 'lightgrey' }}
            >
              Coming Soon
            </Typography>
          </div>
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/routes/alchemy/start.js